import {NgbDateStruct} from '@ng-bootstrap/ng-bootstrap';
import format from 'date-fns/format';

export class DateCommonHelper {

  public static dateToNgbDateStruct(date: Date): NgbDateStruct {
    return {
      year: date.getFullYear(),
      month: date.getMonth() + 1,
      day: date.getDate()
    } as NgbDateStruct;
  }

  public static ngbDateStructToString(date: NgbDateStruct, formatString = 'Y-MM-dd'): string {
    return format(new Date(date.year, date.month - 1, date.day), formatString);
  }
}
